import { Component, Input, type OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { CurrencyPipe, TitleCasePipe } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';

@Component({
  selector: 'app-rate-detail',
  imports: [MatCardModule, MatDividerModule, CurrencyPipe, TitleCasePipe],
  templateUrl: './rate-detail.component.html',
  styleUrl: './rate-detail.component.scss',
})
export class RateDetailComponent implements OnInit {
  @Input() panelData: any;
  pageLabels: any;
  pageReady = false;
  constructor(private readonly cms: CmsService) {}

  ngOnInit(): void {
    this.cms.getContent('oas-account-detail-side-panel-model', 'OAS Account Detail Panel').subscribe((data) => {
      this.pageLabels = data;
      this.pageReady = true;
    });
  }
}
